<template>
    <span class="icon-cart">
        <FontAwesomeIcon icon="fa-light fa-shopping-cart"/>
        <span
            v-if="cartItemsCount > 0"
            class="icon-cart__counter"
            style="background: #E42313"
        >{{ formatNumber(cartItemsCount, 0) }}</span>
    </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons';

library.add(faShoppingCart);

const store = useStore();
const cartItemsCount = computed(() => store.getters['cart/countAll']);
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.icon-cart {
  position: relative;
  width: fit-content;
  display: block;

  &__counter {
    background-color: $primary;
    font-size: .416667em;
    min-height: 1em;
    min-width: 1em;
    max-width: 5em;
    color: #FFFFFF;
    line-height: 1;
    padding: .25em .5em;
    overflow: hidden;
    text-align: center;
    transform-origin: top right;
    position: absolute;
    border-radius: 1em;
    top: -.5em;
    right: -.5em;
    font-weight: 700;
  }
}
</style>
